var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632893039581,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8003,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M993.6 110.4c-20.8-17.6-46.4-25.6-72-25.6L340.8 128c-46.4 8-84.8 51.2-84.8 97.6v473.6c-25.6-8-56-17.6-84.8-17.6-94.4 0-171.2 56-171.2 128s76.8 128 171.2 128 171.2-56 171.2-128V448l596.8-46.4v256c-25.6-12.8-56-17.6-84.8-17.6-94.4 0-171.2 56-171.2 128s76.8 128 171.2 128S1024 840 1024 768V182.4c0-24-12.8-49.6-30.4-72zM171.2 852.8c-51.2 0-84.8-25.6-84.8-43.2S120 768 171.2 768s84.8 25.6 84.8 43.2-33.6 41.6-84.8 41.6z m681.6-41.6c-51.2 0-84.8-25.6-84.8-43.2s33.6-43.2 84.8-43.2c51.2 0 84.8 25.6 84.8 43.2s-33.6 43.2-84.8 43.2z m-512-585.6c0-4.8 4.8-8 8-8l580.8-43.2c4.8 0 4.8 0 4.8 4.8 0 0 4.8 4.8 4.8 8V320l-596.8 46.4v-140.8z",
    "p-id": 8004
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.bbf4a1bc.svg";
export { ForwardRef as ReactComponent };